import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./header.module.scss";
import { connect } from "react-redux";
import {
    setActiveFeature,
    setSearchBarVisible,
    setActiveFilter,
    setActivePage,
    setMapType,
    setBasemap,
} from "../../actions/ui";
import {
    selectSearchBarVisible,
    selectActiveFilters,
    selectActivePage,
    selectActiveFeature,
    selectAllHubs,
    selectActiveProject,
    selectViewingHub,
    selectIsInternal,
    selectMapType,
    selectBasemap,
} from "../../reducers/";
import Search from "../search";
import NSWSvg from "./nsw-svg";
import { getIcon } from "../../modules/hub";
import { projectShape } from "../../modules/project";
import geojsonConfig from "../../modules/geojsonConfig";

class Header extends Component {
    constructor(props) {
        super();
        this.state = {
            filterBoxOpen: false,
            mapTypeBoxOpen: false,
        };
        this.handleToggleFilterClick = this.handleToggleFilterClick.bind(this);
    }
    handleToggleFilterClick(hub) {
        return e => {
            return this.props.setActiveFilter(hub);
        };
    }
    isActiveFilter(hub) {
        const { activeFilters } = this.props;

        if (activeFilters.length === 0) {
            // if no filters are clicked, then they are all lit up
            return true;
        }
        if (!activeFilters.includes(hub)) {
            // If filters are clicked but this is enabled, light up
            return true;
        }
        // We are filtering and this one isn't active
        return false;
    }
    renderFilter() {
        const { viewingHub } = this.props;
        if (viewingHub) return null;
        if (this.state.filterBoxOpen === false) {
            return (
                <button
                    className={`${styles.headerButton} ${styles.filterButton}`}
                    onClick={() => this.setState({ filterBoxOpen: true })}
                >
                    <span>Filter</span>
                </button>
            );
        }
        const filterItems = this.props.hubs.map(hub => {
            return (
                <div key={hub} className={styles.filterItem}>
                    <button
                        data-active={this.isActiveFilter(hub)}
                        className={styles.filterItemButton}
                        onClick={this.handleToggleFilterClick(hub)}
                    >
                        <img src={getIcon(hub)} alt={hub} />
                    </button>
                    <label>{hub}</label>
                </div>
            );
        });

        return (
            <div className={styles.filters}>
                <div className={styles.filtersHeader}>
                    <span>Filter</span>
                    <button
                        onClick={() => this.setState({ filterBoxOpen: false })}
                        className={styles.filterCloseButton}
                    >
                        &times;
                    </button>
                </div>
                {filterItems}
            </div>
        );
    }

    renderBasemapToggle() {
        const { basemap, setBasemap } = this.props;
        const handler = () => {
            const newBasemap = basemap === "ROADMAP" ? "HYBRID" : "ROADMAP";
            setBasemap(newBasemap);
        };

        const buttonText = basemap === "ROADMAP" ? "Satellite" : "Roads";
        return (
            <button onClick={handler} className={styles.headerButton}>
                {buttonText}
            </button>
        );
    }

    renderMapType() {
        if (!this.props.isInternal) return;
        if (this.state.mapTypeBoxOpen === false) {
            return (
                <button
                    className={`${styles.headerButton} ${styles.filterButton}`}
                    onClick={() => this.setState({ mapTypeBoxOpen: true })}
                >
                    <span>Map Type</span>
                </button>
            );
        }
        const mapTypeItems = Object.keys(geojsonConfig).map(mapType => {
            const name = geojsonConfig[mapType].displayName;
            return (
                <div key={mapType} className={styles.filterItem}>
                    <button
                        onClick={() => this.props.setMapType(mapType)}
                        data-active={this.props.mapType === mapType}
                        disabled={this.props.mapType === mapType}
                        className={styles.mapTypeButton}
                    >
                        {name}
                    </button>
                </div>
            );
        });
        return (
            <div className={styles.filters}>
                <div className={styles.filtersHeader}>
                    <span>Map Type</span>
                    <button
                        onClick={() => this.setState({ mapTypeBoxOpen: false })}
                        className={styles.filterCloseButton}
                    >
                        &times;
                    </button>
                </div>
                {mapTypeItems}
            </div>
        );
    }

    renderActiveFeatureName() {
        if (this.props.activeFeature) {
            return (
                <p className={styles.activeFeatureName}>
                    {this.props.nameSelector(this.props.activeFeature)}
                </p>
            );
        }
        if (this.props.activePage === "map") return null;
        return "NSW";
    }

    renderContent() {
        if (this.props.activeProject) {
            return null;
        }
        if (this.props.searchBarVisible) {
            return (
                <div className={styles.search}>
                    <Search />
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className={styles.left}>
                    <button
                        className={`${styles.searchButton}`}
                        onClick={() => this.props.setSearchBarVisible(true)}
                    >
                        <img
                            src={`/img/search-icon-white.svg`}
                            alt="search icon"
                        />
                    </button>

                    {this.renderActiveFeatureName()}
                </div>
                <div className={styles.right}>
                    {this.renderBasemapToggle()}
                    <button
                        className={styles.headerButton}
                        onClick={() => {
                            this.props.setActiveFeature(null);
                            this.props.setActivePage("map");
                        }}
                    >
                        <NSWSvg />
                    </button>
                    {this.renderMapType()}
                    {this.renderFilter()}
                    <button
                        onClick={() => {
                            const newPage =
                                this.props.activePage === "list"
                                    ? "map"
                                    : "list";
                            this.props.setActivePage(newPage);
                        }}
                        data-page={this.props.activePage}
                        className={`${styles.headerButton} ${styles.toggleButton}`}
                    />
                </div>
            </React.Fragment>
        );
    }
    render() {
        return <div className={styles.header}>{this.renderContent()}</div>;
    }
}

Header.propTypes = {
    nameSelector: PropTypes.func.isRequired,
    setActiveFilter: PropTypes.func.isRequired,
    setActiveFeature: PropTypes.func.isRequired,
    setSearchBarVisible: PropTypes.func.isRequired,
    setActivePage: PropTypes.func.isRequired,
    activePage: PropTypes.string.isRequired,
    searchBarVisible: PropTypes.bool.isRequired,
    activeFilters: PropTypes.arrayOf(PropTypes.string),
    activeFeature: PropTypes.object,
    hubs: PropTypes.arrayOf(PropTypes.string),
    activeProject: PropTypes.shape(projectShape),
    viewingHub: PropTypes.string,
    isInternal: PropTypes.bool.isRequired,
    mapType: PropTypes.string.isRequired,
    basemap: PropTypes.string.isRequired,
    setMapType: PropTypes.func.isRequired,
    setBasemap: PropTypes.func.isRequired,
};

const mapStateToProps = s => ({
    searchBarVisible: selectSearchBarVisible(s),
    activeFilters: selectActiveFilters(s),
    activePage: selectActivePage(s),
    activeFeature: selectActiveFeature(s),
    activeProject: selectActiveProject(s),
    hubs: selectAllHubs(s),
    viewingHub: selectViewingHub(s),
    isInternal: selectIsInternal(s),
    mapType: selectMapType(s),
    basemap: selectBasemap(s),
});
const mapDispatchToProps = {
    setActiveFeature,
    setSearchBarVisible,
    setActiveFilter,
    setActivePage,
    setMapType,
    setBasemap,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);



// WEBPACK FOOTER //
// ./src/components/header/header.js